import React from 'react'
import PropTypes from 'prop-types'
import { get, find, noop } from 'lodash'

import { formatValue } from 'utils/formatters/value'
import { RadioButtonGroup } from 'components/radioButtonGroup/RadioButtonGroup'
import { FormBlock } from 'components/formBlock/FormBlock'

export const FormRadioButtonGroup = ({
  field,
  title,
  isReadonly,
  onChange,
  handleFieldChange,
  options = [],
  keyName = 'id',
  valueName = 'title',
  listType,
  className,
  hideError,
}) => {
  const option = find(options, { [keyName]: field.value })
  const key = get(option, [keyName])
  const value = get(option, [valueName])
  const handleChange = onChange ? onChange : handleFieldChange ? handleFieldChange(field.name) : noop

  return (
    <FormBlock
      title={title}
      readonlyView={formatValue(value)}
      isRequired={!!field.isRequired}
      isReadonly={!!isReadonly}
      className={className}>
      <RadioButtonGroup
        options={options}
        value={key}
        error={!hideError && field.error}
        onChange={handleChange}
        lastRow
        listType={listType}
      />
    </FormBlock>
  )
}

FormRadioButtonGroup.propTypes = {
  field: PropTypes.object.isRequired,
  options: PropTypes.array.isRequired,
  title: PropTypes.node,
  isReadonly: PropTypes.bool,
  onChange: PropTypes.func,
  handleFieldChange: PropTypes.func,
  hideError: PropTypes.bool,
  keyName: PropTypes.string,
  valueName: PropTypes.string,
  className: PropTypes.string,
  listType: PropTypes.oneOf(['block', 'inline', 'columns']),
}
